// extracted by mini-css-extract-plugin
module.exports = {"Checkmark":"checkmark_Checkmark__Ka_uX","inherit":"checkmark_inherit__GalFQ","success":"checkmark_success__cW55H","successStrong":"checkmark_successStrong__5xdBv"};